var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareLineIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "122.661px",
    height: "122.88px",
    viewBox: "0 0 122.661 122.88",
    enableBackground: "new 0 0 122.661 122.88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.26,0h80.142c11.692,0,21.26,9.706,21.26,21.569v79.741 c0,11.864-9.567,21.569-21.26,21.569H21.26C9.566,122.88,0,113.175,0,101.311V21.569C0,9.706,9.566,0,21.26,0L21.26,0z M21.674,11.14h79.312c5.855,0,10.647,4.788,10.647,10.641v79.313c0,5.855-4.792,10.646-10.647,10.646H21.674 c-5.855,0-10.646-4.79-10.646-10.646V21.78C11.027,15.928,15.818,11.14,21.674,11.14L21.674,11.14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLineIcon);
export default __webpack_public_path__ + "static/media/square-line-icon.c981c6aab45ba98c017ce928eac51544.svg";
export { ForwardRef as ReactComponent };